import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { userApi } from '../api/axios';
import { CadreCentre, EnTeteAcces } from '../components/CadreAcces';
import { COULEURS } from '../theme/charte';
import RenvoiConfirmation from '../components/RenvoiConfirmation';

type Status = 'loading' | 'success' | 'error' | 'no-token';

const Pastille: React.FC<{ couleur: string; children: React.ReactNode }> = ({ couleur, children }) => (
  <div aria-hidden style={{
    width: 56, height: 56, borderRadius: '50%', border: `1.5px solid ${couleur}`, color: couleur,
    display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '26px',
  }}>{children}</div>
);

const Verify: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<Status>('loading');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('no-token');
      return;
    }
    userApi
      .get(`/user/client-verify?token=${encodeURIComponent(token)}`)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [searchParams]);

  const content: Record<Status, { icon: React.ReactNode; title: string; sub: string }> = {
    loading: {
      icon: <span className="roue" style={{ display: 'block', margin: '0 auto', width: 40, height: 40 }} />,
      title: 'Vérification en cours…',
      sub: 'Veuillez patienter.',
    },
    success: {
      icon: <Pastille couleur={COULEURS.succes}>✓</Pastille>,
      title: 'Adresse confirmée',
      sub: 'Votre adresse email est confirmée. Vous pouvez maintenant vous connecter.',
    },
    error: {
      icon: <Pastille couleur={COULEURS.erreur}>!</Pastille>,
      title: 'Lien invalide',
      sub: "Ce lien n'est plus valable : il a peut-être déjà servi. Si votre adresse est déjà confirmée, connectez-vous.",
    },
    'no-token': {
      icon: <Pastille couleur={COULEURS.erreur}>!</Pastille>,
      title: 'Lien invalide',
      sub: "Ce lien est incomplet. Ouvrez-le directement depuis l'email reçu, sans le modifier.",
    },
  };

  const { icon, title, sub } = content[status];

  return (
    <CadreCentre>
      <div role="status">{icon}</div>
      <EnTeteAcces etiquette="Confirmation de l'adresse" titre={title}>{sub}</EnTeteAcces>
      {status === 'success' && <Link to="/connexion" className="bouton bouton--large">Se connecter</Link>}
      {(status === 'error' || status === 'no-token') && (
        <div className="pile" style={{ gap: '10px' }}>
          <p style={{ fontSize: '14px' }}>Votre compte n'est pas encore confirmé ? Recevez un nouveau lien :</p>
          <RenvoiConfirmation />
        </div>
      )}
      {status !== 'loading' && status !== 'success' && (
        <Link to="/connexion" style={{ fontSize: '13px', fontWeight: 600, textAlign: 'center' }}>Retour à la connexion</Link>
      )}
    </CadreCentre>
  );
};

export default Verify;
